<template>
  <div>
    <v-layout class="pb-4">
      <v-btn
        color="primary"
        @click="abrirDialogEscolherCobertura()"
        block
        width="100%"
      >
        Cobertura estoque de segurança (<strong>{{ cobertura_atual }}</strong>)
      </v-btn>
    </v-layout>

    <SysDialog
      v-model="dialog_escolher_cobertura"
      titulo="Escolha a cobertura"
      :largura="500"
      ocultarAcoes
      @click:hidden-dialog="fecharDialogEscolherCobertura()"
    >
      <template #titulo>
        <div class="d-flex align-center w-full">
          <p class="ma-0 font-20">
            Cobertura do Estoque de Segurança
          </p>
          <v-spacer />
          <v-btn
            color="#000"
            icon
            @click="fecharDialogEscolherCobertura()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

        </div>
        <p class="ma-0 font-12 mt-n2 font-weight-regular text-gray-800">Selecione o tipo da cobertura</p>
      </template>

      <v-radio-group v-model="cobertura_selecionada" class="mt-n4 ml-n2">
        <v-radio
          v-for="(opt, idx) in tipos_coberturas"
          :key="idx"
          :value="opt.id_tipo"
        >
          <template #label>
            <span v-text="opt.descricao" class="ml-2" />
          </template>
        </v-radio>
      </v-radio-group>

      <Automatico
        :fornecedor="fornecedor"
        :cobertura_selecionada="cobertura_selecionada"
        @fechar-dialog-automatico="fechar($event)"
      />

      <Curvas
        :fornecedor="fornecedor"
        :cobertura_selecionada="cobertura_selecionada"
        @fechar-dialog-curvas="fechar($event)"
      />

      <FamiliaProduto
        :fornecedor="fornecedor"
        :cobertura_selecionada="cobertura_selecionada"
        @fechar-dialog-familia-produto="fechar($event)"
      />

      <Fornecedor
        :fornecedor="fornecedor"
        :cobertura_selecionada="cobertura_selecionada"
        @fechar-dialog-fornecedor="fechar($event)"
      />

      <Produtos
        :cobertura_selecionada="cobertura_selecionada"
        :fornecedor="fornecedor"
        @fechar-dialog-produtos="fechar($event)"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '../../padraoDeLayout/SysDialog.vue';
import Automatico from "./Automatico.vue";
import Curvas from './Curvas.vue';
import FamiliaProduto from './FamiliaProduto.vue';
import Fornecedor from './Fornecedor.vue';
import Produtos from './Produtos.vue';
import { buscarTipoFornecedor } from "./RequisicoesAPI";

export default {
  name: "Coberturas",
  components: { SysDialog, Automatico, Produtos, Fornecedor, FamiliaProduto, Curvas },
  props: {
    fornecedor: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dialog_escolher_cobertura: false,
    cobertura_atual: 'Automático',
    cobertura_selecionada: null,
    tipos_coberturas: [
      { id_tipo: 0, descricao: 'Automático' },
      { id_tipo: 1, descricao: 'Por Curva' },
      { id_tipo: 2, descricao: 'Por Segmento' },
      { id_tipo: 3, descricao: 'Por Fornecedor' },
      { id_tipo: 4, descricao: 'Por Produto' },
    ]
  }),
  watch: {
    cobertura_selecionada(valor) {
      if (valor != null) this.dialog_escolher_cobertura = false;
    }
  },
  created() {
    this.carregar();
  },
  methods: {
    carregar() {
      const parametros = {
        id_fornecedor: this.fornecedor.id,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarTipoFornecedor(parametros)
          .then(tipo => this.cobertura_atual = this.tipos_coberturas[tipo.status_tempo_esseg].descricao)
      );
    },
    abrirDialogEscolherCobertura () {
      this.dialog_escolher_cobertura = true;
    },
    fecharDialogEscolherCobertura () {
      this.dialog_escolher_cobertura = false;
      this.cobertura_selecionada = null;
    },
    fechar(evento) {
      this.carregar();
      this.fecharDialogEscolherCobertura();
      if (evento) this.$emit('atualizar-tela-compras');
    }
  }
}
</script>

<style>

</style>
